export default {
  'terms.name': 'Genres',
  'countries.name': 'Pays',
};
